var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle, icon: "magicon-user" } },
        [
          _c(
            "ui-button",
            {
              attrs: { color: "positive", loading: _vm.submitting },
              on: {
                click: function ($event) {
                  return _vm.$refs.form.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-input", {
            attrs: {
              title: "Gebruikersnaam",
              name: "username",
              disabled: true,
              rules: "required",
            },
            model: {
              value: _vm.pendingUser.username,
              callback: function ($$v) {
                _vm.$set(_vm.pendingUser, "username", $$v)
              },
              expression: "pendingUser.username",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              title: "E-mail adres",
              name: "email",
              rules: "required|email",
            },
            model: {
              value: _vm.pendingUser.email,
              callback: function ($$v) {
                _vm.$set(_vm.pendingUser, "email", $$v)
              },
              expression: "pendingUser.email",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "Telefoonnummer", name: "phoneNumber" },
            model: {
              value: _vm.pendingUser.phoneNumber,
              callback: function ($$v) {
                _vm.$set(_vm.pendingUser, "phoneNumber", $$v)
              },
              expression: "pendingUser.phoneNumber",
            },
          }),
          _vm.itemId
            ? _c("ui-form-input", {
                attrs: {
                  title: "Nieuw wachtwoord",
                  type: "password",
                  name: "password",
                },
                model: {
                  value: _vm.pendingUser.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.pendingUser, "password", $$v)
                  },
                  expression: "pendingUser.password",
                },
              })
            : _vm._e(),
          (_vm.pendingUser.password && _vm.pendingUser.password.length) ||
          !_vm.itemId
            ? _c("ui-form-input", {
                attrs: {
                  title: "Wachtwoord herhalen",
                  type: "password",
                  name: "passwordConfirm",
                  rules: "required|confirmed:password",
                },
                model: {
                  value: _vm.passwordConfirm,
                  callback: function ($$v) {
                    _vm.passwordConfirm =
                      typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "passwordConfirm",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }